import { render, staticRenderFns } from "./new-user-guide-add-supplier.vue?vue&type=template&id=3967a4da&scoped=true&"
import script from "./new-user-guide-add-supplier.vue?vue&type=script&lang=js&"
export * from "./new-user-guide-add-supplier.vue?vue&type=script&lang=js&"
import style0 from "./new-user-guide-add-supplier.vue?vue&type=style&index=0&id=3967a4da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3967a4da",
  null
  
)

export default component.exports